/* eslint-disable react/jsx-props-no-spreading */
import { Accordion, AccordionProps } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons';
import { FC, ReactNode } from 'react';

interface Props extends AccordionProps {
  children: ReactNode;
}

const BookitupAccordion: FC<Props> = ({ children, ...rest }) => (
  <Accordion
    variant="separated"
    chevronPosition="left"
    chevron={<IconChevronRight size="1rem" />}
    styles={{
      chevron: {
        '&[data-rotate]': {
          transform: 'rotate(90deg)',
        },
      },
    }}
    {...rest}
  >
    {children}
  </Accordion>
);

export default BookitupAccordion;
